module.exports = __webpack_public_path__ + "8940b0f594250364007e33fdcbbef07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s12.jpg
// module id = 688
// module chunks = 0